module.exports = __webpack_public_path__ + "img/我的.9caf9678.svg";